import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex md:flex-row flex-col items-center md:space-x-3 md:space-y-0 space-y-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Edit", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "View PDF", -1)
const _hoisted_4 = { class: "mt-6 md:text-2xl text-lg font-medium text-neutral-600" }
const _hoisted_5 = { class: "md:inline-block block font-semibold text-neutral-900" }
const _hoisted_6 = { class: "w-full lg:p-6 p-4 mx-auto my-6 border border-gray-200 rounded" }
const _hoisted_7 = { class: "flex items-center justify-between" }
const _hoisted_8 = { class: "grid grid-cols-6 sm:gap-6 gap-3 items-start" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "col-span-6 text-neutral-600 font-medium text-sm" }, " Personal Information ", -1)
const _hoisted_11 = { class: "grid grid-cols-3 md:col-span-3 col-span-6 gap-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Full Name:")
], -1)
const _hoisted_13 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Sex:")
], -1)
const _hoisted_15 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Gender:")
], -1)
const _hoisted_17 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Birthdate:")
], -1)
const _hoisted_19 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_20 = { class: "col-span-1 pb-2 border-b border-gray-100" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Civil Status:")
], -1)
const _hoisted_25 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Contact Number:")
], -1)
const _hoisted_27 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Lives w/ Child:")
], -1)
const _hoisted_29 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Case Number:")
], -1)
const _hoisted_31 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Primary Diagnosis:")
], -1)
const _hoisted_33 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Informant relation to child:")
], -1)
const _hoisted_35 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 md:pb-0 pb-2 md:border-b-0 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Other Relationship:")
], -1)
const _hoisted_37 = { class: "col-span-2 pl-3 md:pb-0 pb-2 md:border-b-0 border-b border-gray-100" }
const _hoisted_38 = { class: "grid grid-cols-3 md:col-span-3 col-span-6 gap-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Services sought:")
], -1)
const _hoisted_40 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Social worker:")
], -1)
const _hoisted_42 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "External referral from:")
], -1)
const _hoisted_44 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Intra-PGH referral from:")
], -1)
const _hoisted_46 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "If inpatient, which ward referred:")
], -1)
const _hoisted_48 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Legal Status:")
], -1)
const _hoisted_50 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Housing Classification:")
], -1)
const _hoisted_52 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Socio Eco Status:")
], -1)
const _hoisted_54 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "No. of Children in Family:")
], -1)
const _hoisted_56 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "No. of Household Members:")
], -1)
const _hoisted_58 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "No. of Families in Household:")
], -1)
const _hoisted_60 = { class: "col-span-2" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "border-t border-gray-200 sm:mt-12 mt-6" }, null, -1)
const _hoisted_62 = { class: "grid grid-cols-6 sm:gap-6 gap-3 items-start" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, null, -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("p", { class: "col-span-12 text-neutral-600 font-medium text-sm" }, " Address and Present Location ", -1)
const _hoisted_65 = { class: "w-full" }
const _hoisted_66 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Address Type:")
], -1)
const _hoisted_68 = { class: "py-2" }
const _hoisted_69 = { class: "font-normal" }
const _hoisted_70 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Address:")
], -1)
const _hoisted_72 = { class: "py-2" }
const _hoisted_73 = { class: "font-normal" }
const _hoisted_74 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Barangay:")
], -1)
const _hoisted_76 = { class: "py-2" }
const _hoisted_77 = { class: "font-normal" }
const _hoisted_78 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "City/Municipality/District:")
], -1)
const _hoisted_80 = { class: "py-2" }
const _hoisted_81 = { class: "font-normal" }
const _hoisted_82 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Province:")
], -1)
const _hoisted_84 = { class: "py-2" }
const _hoisted_85 = { class: "font-normal" }
const _hoisted_86 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Region:")
], -1)
const _hoisted_88 = { class: "py-2" }
const _hoisted_89 = { class: "font-normal" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Direction:")
], -1)
const _hoisted_91 = { class: "py-2" }
const _hoisted_92 = { class: "font-normal" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "border-t border-gray-200 sm:mt-12 mt-6" }, null, -1)
const _hoisted_94 = { class: "grid grid-cols-6 sm:gap-6 gap-3 items-start" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, null, -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("p", { class: "col-span-6 text-neutral-600 font-medium text-sm" }, " Persons Related to Case ", -1)
const _hoisted_97 = { class: "lg:col-span-3 col-span-6 relative w-full" }
const _hoisted_98 = { class: "w-full" }
const _hoisted_99 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Full Name:")
], -1)
const _hoisted_101 = { class: "py-2" }
const _hoisted_102 = { class: "font-normal" }
const _hoisted_103 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Gender:")
], -1)
const _hoisted_105 = { class: "py-2" }
const _hoisted_106 = { class: "font-normal" }
const _hoisted_107 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Relationship:")
], -1)
const _hoisted_109 = { class: "py-2" }
const _hoisted_110 = { class: "font-normal" }
const _hoisted_111 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Birthdate:")
], -1)
const _hoisted_113 = { class: "py-2" }
const _hoisted_114 = { class: "font-normal" }
const _hoisted_115 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Age:")
], -1)
const _hoisted_117 = { class: "py-2" }
const _hoisted_118 = { class: "font-normal" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Contact Number:")
], -1)
const _hoisted_120 = { class: "py-2" }
const _hoisted_121 = { class: "font-normal" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", { class: "border-t border-gray-200 sm:mt-12 mt-5" }, null, -1)
const _hoisted_123 = { class: "grid grid-cols-6 sm:gap-6 gap-3 items-start" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, null, -1)
const _hoisted_125 = /*#__PURE__*/_createElementVNode("p", { class: "col-span-6 text-neutral-600 font-medium text-sm" }, " Contact Numbers ", -1)
const _hoisted_126 = {
  key: 0,
  class: "lg:col-span-3 col-span-6 relative w-full p-4 pr-8 border border-gray-200 rounded"
}
const _hoisted_127 = /*#__PURE__*/_createElementVNode("table", { class: "w-full" }, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", { class: "border-b border-solid border-gray-100" }, [
      /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Label:")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, " Contact Numbers:")
      ])
    ])
  ])
], -1)
const _hoisted_128 = [
  _hoisted_127
]
const _hoisted_129 = { class: "w-full" }
const _hoisted_130 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Label:")
], -1)
const _hoisted_132 = { class: "py-2" }
const _hoisted_133 = { class: "font-normal" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, " Contact Numbers:")
], -1)
const _hoisted_135 = { class: "py-2" }
const _hoisted_136 = { class: "font-normal" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("div", { class: "border-t border-gray-200 sm:mt-12 mt-6" }, null, -1)
const _hoisted_138 = { class: "grid grid-cols-6 sm:gap-6 gap-3 items-start" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, null, -1)
const _hoisted_140 = /*#__PURE__*/_createElementVNode("p", { class: "col-span-6 text-neutral-600 font-medium text-sm" }, " Email Addresses ", -1)
const _hoisted_141 = {
  key: 0,
  class: "lg:col-span-3 col-span-6 relative w-full p-4 pr-8 border border-gray-200 rounded"
}
const _hoisted_142 = /*#__PURE__*/_createElementVNode("table", { class: "w-full" }, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", { class: "border-b border-solid border-gray-100" }, [
      /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Label:")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, " Email Address:")
      ])
    ])
  ])
], -1)
const _hoisted_143 = [
  _hoisted_142
]
const _hoisted_144 = { class: "w-full" }
const _hoisted_145 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_146 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Label:")
], -1)
const _hoisted_147 = { class: "py-2" }
const _hoisted_148 = { class: "font-normal" }
const _hoisted_149 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, " Email Address:")
], -1)
const _hoisted_150 = { class: "py-2" }
const _hoisted_151 = { class: "font-normal" }
const _hoisted_152 = /*#__PURE__*/_createElementVNode("div", { class: "border-t border-gray-200 sm:mt-12 mt-6" }, null, -1)
const _hoisted_153 = { class: "grid grid-cols-6 sm:gap-6 gap-3 items-start" }
const _hoisted_154 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, null, -1)
const _hoisted_155 = /*#__PURE__*/_createElementVNode("p", { class: "col-span-6 text-sm font-medium text-neutral-600" }, " Incest Cases ", -1)
const _hoisted_156 = { class: "col-span-6" }
const _hoisted_157 = { class: "w-full" }
const _hoisted_158 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Regular sleeping arrangement:")
], -1)
const _hoisted_160 = { class: "py-2" }
const _hoisted_161 = { class: "font-normal" }
const _hoisted_162 = { class: "align-top border-b border-gray-100 border-solid" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Specify:")
], -1)
const _hoisted_164 = { class: "py-2" }
const _hoisted_165 = { class: "font-normal" }
const _hoisted_166 = { class: "align-top border-b border-gray-100 border-solid" }
const _hoisted_167 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, " Same bed / mat with:")
], -1)
const _hoisted_168 = { class: "py-2 frm-description" }
const _hoisted_169 = { class: "font-normal" }
const _hoisted_170 = { class: "align-top border-b border-gray-100 border-solid" }
const _hoisted_171 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, " Same room with:")
], -1)
const _hoisted_172 = { class: "py-2 frm-description" }
const _hoisted_173 = { class: "font-normal" }
const _hoisted_174 = { class: "align-top border-b border-gray-100 border-solid" }
const _hoisted_175 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, " Living arrangement at time of abuse:")
], -1)
const _hoisted_176 = { class: "py-2 frm-description" }
const _hoisted_177 = { class: "font-normal" }
const _hoisted_178 = { class: "align-top" }
const _hoisted_179 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, " Living arrangement at present:")
], -1)
const _hoisted_180 = { class: "py-2 frm-description" }
const _hoisted_181 = { class: "font-normal" }

import { ref, onMounted, computed } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import { EyeIcon } from "@heroicons/vue/24/solid";
import { useRouter, useRoute } from "vue-router";  
import { IntakeShow } from "@/interfaces/Cases/Intake"; 
import IntakeFormService from "@/classes/Cases/IntakeForms/IntakeFormService";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import { BirthdayClassification } from "@/views/enums/BirthdayClassification"; 
import PencilUnderlineIcon from "@/components/icons/pencilUnderlineIcon.vue"; 
// ***************************************** Offline Imports ****************
import IndexPageService from "@/classes/Cases/Intake/IndexPage/IndexPageService";
import { useNetworkStore } from "@/store/network";

export default /*#__PURE__*/_defineComponent({
  __name: 'ViewPage',
  setup(__props) {

const networkStore = useNetworkStore();
 const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
// ***************************************** ********************************
const router = useRouter();
const route = useRoute();
const patientId = ref<number | null>(route.params.patient);
const caseId = ref<number | null>(route.params.case);   
const showConfirmation = ref<boolean>(false);
const item = ref<IntakeShow>({}); 
const errorMessage = ref<string>('')
const offlineParams = ref<string>(route.query.offline);

const getData = async (): Promise<any> => {
	if (isNetworkAvailable.value) {
        await fetch();
       
    } else {
 
        const response = await IndexPageService.view(patientId.value, caseId.value);	 
        if (!response?.hasCurrentAddress) {
            errorMessage.value = 'No current address set yet';
            showConfirmation.value = true;
            return;
        }
        Object.assign(item.value, response);
    } 
};

const fetch = async ():void => {
	// IntakeFormService
	await IntakeFormService
		.index(
			patientId.value,
			caseId.value,  
		)
		.then(({data}) => {
			console.log(data);
			
			Object.assign(item.value, data.item)
			console.log(item.value);
		}).catch((errors) => {
			console.log(errors);
			console.log(errors.response.data.message)
			if (errors.response.data.message == 'No permanent address set yet' || errors.response.data.message == 'No present address set yet') {
				errorMessage.value = errors.response.data.message;
			} else {
				errorMessage.value = "Intake has no data, would you like to fill up the form?"
			}
			showConfirmation.value = true;
		})
}

const gotoEdit = ():void => {
	router.replace(
		`/patient/${patientId.value}/cases/${caseId.value}/intake/personal-information${
			offlineParams.value ? '?offline=true' : ''
		}`
	)
}
const back = ():void => {
	showConfirmation.value = false
	router.replace(
		`/patient/${patientId.value}/cases/${caseId.value}/edit${offlineParams.value ? '?offline=true' : ''}`
	)
}

const generatePDFAccess = ():void => {
	IntakeFormService
		.generatePDFAccess(
			patientId.value,
			caseId.value
		)
		.then(({data}) => {
			if(data.token){
				downloadPDF(data.token)
			}
		}).catch((errors) => {
			console.log(errors);
		})
}

const downloadPDF = (token:string):void => {
	IntakeFormService
		.downloadPDF(
			patientId.value,
			caseId.value,
			token
		)
		.then(({data}) => {
			console.log(data);
		}).catch((errors) => {
			console.log(errors);
		})

}

onMounted(async () => {
	await getData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backTitle: "View Intake",
    backLink: `/patient/${patientId.value}/cases/${caseId.value}/edit${offlineParams.value ? '?offline=true' : ''}`,
    hasBackClass: "flex md:justify-between md:items-center md:flex-row flex-col"
  }, {
    lowerRight: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (gotoEdit())),
          class: "md:w-auto w-full md:mt-0 mt-6"
        }, [
          _createVNode(ButtonComponent, { customClass: "primary md:w-auto w-full" }, {
            default: _withCtx(() => [
              _createVNode(PencilUnderlineIcon, { class: "object-contain w-4 h-4 mr-1 icon" }),
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        (isNetworkAvailable.value)
          ? (_openBlock(), _createBlock(ButtonComponent, {
              key: 0,
              size: "large",
              customClass: "bg-green-600 hover:bg-green-700 text-white transition border border-green-600 hover:border-green-700 md:w-auto w-full md:mt-0 mt-6",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (generatePDFAccess()))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(EyeIcon), { class: "w-5 h-5 mr-2 -ml-1 icon" }),
                _hoisted_3
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_4, [
        _createTextVNode("Patient's Name: "),
        _createElementVNode("span", _hoisted_5, _toDisplayString(item.value?.name), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(SectionTitle, { title: "Intake" })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("p", null, _toDisplayString(item.value?.name), 1)
            ]),
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("p", null, _toDisplayString(item.value?.sex_form || item.value?.sex), 1)
            ]),
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("p", null, _toDisplayString(item.value?.gender), 1)
            ]),
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("p", null, _toDisplayString(item.value?.birthdate || "Unknown"), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              (_unref(BirthdayClassification).APPROXIMATE_AGE == item.value?.birthday_classification)
                ? (_openBlock(), _createElementBlock("p", _hoisted_21, " Approximate Age: "))
                : (_openBlock(), _createElementBlock("p", _hoisted_22, " Age: "))
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("p", null, _toDisplayString(item.value?.age) + "  ", 1)
            ]),
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("p", null, _toDisplayString(item.value?.civil_status), 1)
            ]),
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("p", null, _toDisplayString(item.value?.contacts), 1)
            ]),
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("p", null, _toDisplayString(item.value?.lives_w_child), 1)
            ]),
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("p", null, _toDisplayString(item.value?.case_number), 1)
            ]),
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("p", null, _toDisplayString(item.value?.primary_diagnosis), 1)
            ]),
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("p", null, _toDisplayString(item.value?.informant_relation_child), 1)
            ]),
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("p", null, _toDisplayString(item.value?.other_relationship), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("p", null, _toDisplayString(item.value?.services_sought), 1)
            ]),
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("p", null, _toDisplayString(item.value?.social_worker), 1)
            ]),
            _hoisted_43,
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("p", null, _toDisplayString(item.value?.external_referral), 1)
            ]),
            _hoisted_45,
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("p", null, _toDisplayString(item.value?.intra_referral), 1)
            ]),
            _hoisted_47,
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("p", null, _toDisplayString(item.value?.inpatient_referred), 1)
            ]),
            _hoisted_49,
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("p", null, _toDisplayString(item.value?.legal_status), 1)
            ]),
            _hoisted_51,
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("p", null, _toDisplayString(item.value?.housing_classification), 1)
            ]),
            _hoisted_53,
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("p", null, _toDisplayString(item.value?.socio_economic_status), 1)
            ]),
            _hoisted_55,
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("p", null, _toDisplayString(item.value?.no_children_in_family), 1)
            ]),
            _hoisted_57,
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("p", null, _toDisplayString(item.value?.no_household_members), 1)
            ]),
            _hoisted_59,
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("p", null, _toDisplayString(item.value?.no_family_in_household), 1)
            ])
          ])
        ]),
        _hoisted_61,
        _createElementVNode("div", _hoisted_62, [
          _hoisted_63,
          _hoisted_64,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value.addresses, (address) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "lg:col-span-12 col-span-6 relative w-full p-4 pr-8 border border-gray-200 rounded",
              key: address.id
            }, [
              _createElementVNode("table", _hoisted_65, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", _hoisted_66, [
                    _hoisted_67,
                    _createElementVNode("td", _hoisted_68, [
                      _createElementVNode("p", _hoisted_69, _toDisplayString(address?.address_type), 1)
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_70, [
                    _hoisted_71,
                    _createElementVNode("td", _hoisted_72, [
                      _createElementVNode("p", _hoisted_73, _toDisplayString(address?.current), 1)
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_74, [
                    _hoisted_75,
                    _createElementVNode("td", _hoisted_76, [
                      _createElementVNode("p", _hoisted_77, _toDisplayString(address?.cur_barangay), 1)
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_78, [
                    _hoisted_79,
                    _createElementVNode("td", _hoisted_80, [
                      _createElementVNode("p", _hoisted_81, _toDisplayString(address?.cur_city), 1)
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_82, [
                    _hoisted_83,
                    _createElementVNode("td", _hoisted_84, [
                      _createElementVNode("p", _hoisted_85, _toDisplayString(address?.cur_province), 1)
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_86, [
                    _hoisted_87,
                    _createElementVNode("td", _hoisted_88, [
                      _createElementVNode("p", _hoisted_89, _toDisplayString(address?.cur_region), 1)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_90,
                    _createElementVNode("td", _hoisted_91, [
                      _createElementVNode("p", _hoisted_92, _toDisplayString(address?.current_directions), 1)
                    ])
                  ])
                ])
              ])
            ]))
          }), 128))
        ]),
        _hoisted_93,
        _createElementVNode("div", _hoisted_94, [
          _hoisted_95,
          _hoisted_96,
          _createElementVNode("div", _hoisted_97, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value.familyComposition, (li) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "mb-1 p-4 pr-8 border border-gray-200 rounded",
                key: li.name
              }, [
                _createElementVNode("table", _hoisted_98, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", _hoisted_99, [
                      _hoisted_100,
                      _createElementVNode("td", _hoisted_101, [
                        _createElementVNode("p", _hoisted_102, _toDisplayString(li?.name), 1)
                      ])
                    ]),
                    _createElementVNode("tr", _hoisted_103, [
                      _hoisted_104,
                      _createElementVNode("td", _hoisted_105, [
                        _createElementVNode("p", _hoisted_106, _toDisplayString(li?.gender), 1)
                      ])
                    ]),
                    _createElementVNode("tr", _hoisted_107, [
                      _hoisted_108,
                      _createElementVNode("td", _hoisted_109, [
                        _createElementVNode("p", _hoisted_110, _toDisplayString(li?.relationship), 1)
                      ])
                    ]),
                    _createElementVNode("tr", _hoisted_111, [
                      _hoisted_112,
                      _createElementVNode("td", _hoisted_113, [
                        _createElementVNode("p", _hoisted_114, _toDisplayString(li.birthdate), 1)
                      ])
                    ]),
                    _createElementVNode("tr", _hoisted_115, [
                      _hoisted_116,
                      _createElementVNode("td", _hoisted_117, [
                        _createElementVNode("p", _hoisted_118, _toDisplayString(li?.computed_age || li?.age), 1)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_119,
                      _createElementVNode("td", _hoisted_120, [
                        _createElementVNode("p", _hoisted_121, _toDisplayString(li.contacts || li.contact), 1)
                      ])
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _hoisted_122,
        _createElementVNode("div", _hoisted_123, [
          _hoisted_124,
          _hoisted_125,
          (!item.value.contactNumbers)
            ? (_openBlock(), _createElementBlock("div", _hoisted_126, _hoisted_128))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.value.contactNumbers, (li) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: li.label,
                  class: "lg:col-span-3 col-span-6 relative w-full p-4 pr-8 border border-gray-200 rounded"
                }, [
                  _createElementVNode("table", _hoisted_129, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", _hoisted_130, [
                        _hoisted_131,
                        _createElementVNode("td", _hoisted_132, [
                          _createElementVNode("p", _hoisted_133, _toDisplayString(li?.label), 1)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_134,
                        _createElementVNode("td", _hoisted_135, [
                          _createElementVNode("p", _hoisted_136, _toDisplayString(li?.number), 1)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
        ]),
        _hoisted_137,
        _createElementVNode("div", _hoisted_138, [
          _hoisted_139,
          _hoisted_140,
          (!item.value.emailAdresses)
            ? (_openBlock(), _createElementBlock("div", _hoisted_141, _hoisted_143))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.value.emailAdresses, (li) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: li.label,
                  class: "lg:col-span-3 col-span-6 relative w-full p-4 pr-8 border border-gray-200 rounded"
                }, [
                  _createElementVNode("table", _hoisted_144, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", _hoisted_145, [
                        _hoisted_146,
                        _createElementVNode("td", _hoisted_147, [
                          _createElementVNode("p", _hoisted_148, _toDisplayString(li?.label), 1)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_149,
                        _createElementVNode("td", _hoisted_150, [
                          _createElementVNode("p", _hoisted_151, _toDisplayString(li?.email), 1)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
        ]),
        _hoisted_152,
        _createElementVNode("div", _hoisted_153, [
          _hoisted_154,
          _hoisted_155,
          _createElementVNode("div", _hoisted_156, [
            _createElementVNode("table", _hoisted_157, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_158, [
                  _hoisted_159,
                  _createElementVNode("td", _hoisted_160, [
                    _createElementVNode("p", _hoisted_161, _toDisplayString(item.value.incest?.sleeping_arrangement), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_162, [
                  _hoisted_163,
                  _createElementVNode("td", _hoisted_164, [
                    _createElementVNode("p", _hoisted_165, _toDisplayString(item.value.incest?.others), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_166, [
                  _hoisted_167,
                  _createElementVNode("td", _hoisted_168, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", _hoisted_169, _toDisplayString(item.value.incest?.same_bed_with), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_170, [
                  _hoisted_171,
                  _createElementVNode("td", _hoisted_172, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", _hoisted_173, _toDisplayString(item.value.incest?.same_room_with), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_174, [
                  _hoisted_175,
                  _createElementVNode("td", _hoisted_176, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value.incest?.abused.form, (li) => {
                      return (_openBlock(), _createElementBlock("ul", { key: li }, [
                        _createElementVNode("li", _hoisted_177, _toDisplayString(li), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("tr", _hoisted_178, [
                  _hoisted_179,
                  _createElementVNode("td", _hoisted_180, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value.incest?.present.form, (li) => {
                      return (_openBlock(), _createElementBlock("ul", { key: li }, [
                        _createElementVNode("li", _hoisted_181, _toDisplayString(li), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(ConfirmationModal, {
        show: showConfirmation.value,
        onCancel: _cache[2] || (_cache[2] = ($event: any) => (back())),
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (gotoEdit())),
        "action-text": "Create",
        "cancel-text": "Back",
        title: "Warning!",
        typeTwo: "",
        content: errorMessage.value
      }, null, 8, ["show", "content"])
    ]),
    _: 1
  }, 8, ["backLink"]))
}
}

})